import React from 'react';

var SvgGlobeFilledIcon = function SvgGlobeFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm2.019-2.335 1.89 1.89c.378.379.591.892.591 1.427v.518a1 1 0 0 0 1 1 1.5 1.5 0 0 1 1.5 1.5v1.5a5.502 5.502 0 0 0 5.216-3.75h-1.216a.25.25 0 0 1-.25-.25v-.5c0-.69-.56-1.25-1.25-1.25h-2.5a1.255 1.255 0 0 1-.764-2.248l.462-.357a.89.89 0 0 0 .347-.707v-.04c0-.747.606-1.353 1.353-1.353h.057c.193 0 .37-.069.509-.184a5.5 5.5 0 0 0-6.945 2.804Z"
  }));
};
SvgGlobeFilledIcon.displayName = "GlobeFilledIcon";

export { SvgGlobeFilledIcon as S };
